import React from 'react';
import { FileText } from 'lucide-react';

const PdfPlaceholder: React.FC = () => {
  return (
    <div className="mx-auto w-[794px] h-[1123px] rounded border border-dashed border-gray-300 bg-gray-50 shadow-sm dark:border-gray-600 dark:bg-boxdark">
      <div className="flex h-full flex-col items-center justify-center gap-3 px-4 py-6 text-center">
        <FileText className="h-12 w-12 text-gray-400 dark:text-gray-500" />
        <p className="text-sm text-gray-500 dark:text-gray-400">
          No se ha seleccionado ningún documento.
        </p>
        <p className="text-xs text-gray-400 dark:text-gray-500">
          Por favor, seleccione un tipo de documento para previsualizarlo aquí.
        </p>
      </div>
    </div>
  );
};

export default PdfPlaceholder;
